import { Api } from '@axiom/ui';
import type { Candidate, CandidateContactInformation } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateContactInformationApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  readContactInformation(candidateId: Candidate['id']) {
    return super.read<{ data: CandidateContactInformation }>({
      endpoint: `/candidates/${candidateId}/contactInformation`,
      method: 'GET',
    });
  }

  async updateContactInformation(
    candidateId: Candidate['id'],
    body: Pick<CandidateContactInformation, 'preferredContactMethod'>
  ) {
    return super.write<{ data: null }>({
      endpoint: `/candidates/${candidateId}/contactInformation`,
      body,
      method: 'PUT',
    });
  }

  async refreshContactInformation(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/contactInformation`);
  }
}

export const CandidateContactInformationApi =
  new CandidateContactInformationApiClass();
